import React, { Component } from "react";

import "./ListPage.css";

export default class ListPageContainer extends Component {
  render() {
    const { children } = this.props;
    return <div className="nc-list-page-container">{children}</div>;
  }
}
